import React from "react";
import { ShieldCheck, Zap, Users, Scale } from "lucide-react";

const ITEMS = [
  {
    icon: ShieldCheck,
    title: "La bonne pièce. Sans erreur.",
    desc: "Vérification OEM croisée via le code mine et le VIN de votre carte grise.",
    testid: "trust-item-oem",
  },
  {
    icon: Zap,
    title: "Identification IA en 1,2s",
    desc: "Notre moteur reconnaît marque, modèle, motorisation et finition en temps réel.",
    testid: "trust-item-speed",
  },
  {
    icon: Users,
    title: "13 fournisseurs comparés",
    desc: "Oscaro, Autodoc, Mister Auto, Mecatechnic, Motoblouz & d'autres — tous dans un seul écran.",
    testid: "trust-item-suppliers",
  },
  {
    icon: Scale,
    title: "100 % neutre & transparent",
    desc: "Nous ne vendons rien. Vos clics d'affiliation nous rémunèrent sans surcoût pour vous.",
    testid: "trust-item-neutral",
  },
];

export const TrustSection = () => (
  <section
    id="trust"
    data-testid="reassurance-trust-section"
    className="mx-auto max-w-7xl px-4 py-16 sm:px-8"
  >
    <div className="mb-10 text-center">
      <span className="font-mono text-xs uppercase tracking-widest text-cyan-400">
        Pourquoi Autopièce Malin
      </span>
      <h2 className="mt-2 font-heading text-3xl font-extrabold text-slate-50 sm:text-4xl">
        La bonne pièce, du premier coup
      </h2>
      <p className="mx-auto mt-3 max-w-2xl text-slate-400">
        Fini les retours en poste et les erreurs de référence. Notre moteur croise
        votre véhicule avec les catalogues des plus grands fournisseurs français.
      </p>
    </div>

    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {ITEMS.map(({ icon: Icon, title, desc, testid }) => (
        <div
          key={title}
          data-testid={testid}
          className="surface-card surface-card-hover rounded-2xl p-6"
        >
          <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-cyan-500/10 ring-1 ring-cyan-500/30">
            <Icon className="h-5 w-5 text-cyan-300" />
          </div>
          <h3 className="font-heading text-lg font-bold text-slate-50">{title}</h3>
          <p className="mt-2 text-sm text-slate-400">{desc}</p>
        </div>
      ))}
    </div>
  </section>
);
